import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-inverse",
  "use": "icon-arrow-down-inverse-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down-inverse\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.50001 4V10.7929L10.6465 8.64645L11.3536 9.35355L8.00001 12.7071L4.64645 9.35355L5.35356 8.64645L7.50001 10.7929V4H8.50001Z\" fill=\"#ffffff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol